import { Eye } from 'lucide-react'

import { ROLE_DISPLAY } from '@/lib/auth/permissionMatrix'
import { useAuth } from '@/lib/auth/useAuth'
import { useDevRolePreviewControls } from '@/lib/auth/useEffectiveRole'
import { Button } from '@/components/ui/button'

export function DevRolePreviewBanner() {
  const { user } = useAuth()
  const controls = useDevRolePreviewControls()
  if (!import.meta.env.DEV || !controls?.isPreviewActive || !user || !controls.previewRole) {
    return null
  }

  return (
    <div
      className="flex flex-wrap items-center justify-center gap-2 border-b border-warning/30 bg-warning/10 px-4 py-1.5 text-xs text-warning-foreground"
      role="status"
    >
      <Eye className="h-3.5 w-3.5" />
      <span>
        Simulando papel <strong>{ROLE_DISPLAY[controls.previewRole]}</strong> (real:{' '}
        {ROLE_DISPLAY[user.role]}). Navegação e overlays usam a visão simulada.
      </span>
      <Button type="button" variant="ghost" size="sm" className="h-7 text-xs" onClick={controls.clearPreview}>
        Voltar ao real
      </Button>
    </div>
  )
}
